import { queryClient } from '@repo/lib/react-query';
import type { AppRouter } from '@repo/trpc-router';
// import { transformer } from '@repo/trpc-router/utils/transformer';
import { getCountryLanguage, getToken } from '@repo/utils';
import { createTRPCClient, httpBatchLink, loggerLink } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';

interface CreateTrpcOptions {
    baseUrl: string;
}

const normalizeBaseUrl = (value: string): string => {
    let end = value.length;

    while (end > 0 && value[end - 1] === '/') {
        end -= 1;
    }

    return `${value.slice(0, end)}/`;
};

export const createTrpc = (options: CreateTrpcOptions): ReturnType<typeof createTrpcClient> => {
    const baseUrl = normalizeBaseUrl(options.baseUrl);

    return createTrpcClient(baseUrl);
};

const createTrpcClient = (baseUrl: string) => {
    try {
        const client = createTRPCClient<AppRouter>({
            links: [
                loggerLink({
                    enabled: (opts) =>
                        (process.env.NODE_ENV === 'development' && 'window' in globalThis) ||
                        (opts.direction === 'down' && opts.result instanceof Error),
                }),
                httpBatchLink({
                    url: baseUrl,
                    async headers({ opList }) {
                        const contextHeaders: Record<string, string> = {};

                        for (const op of opList) {
                            const headers = op.context.headers;

                            if (headers && typeof headers === 'object' && !Array.isArray(headers)) {
                                for (const [key, value] of Object.entries(headers)) {
                                    if (typeof value === 'string') {
                                        contextHeaders[key] = value;
                                    }
                                }
                            }
                        }

                        return {
                            'authorization': `Bearer ${await getToken()}`,
                            'x-countrycode': getCountryLanguage().country,
                            'x-request-id': crypto.randomUUID(),
                            ...contextHeaders,
                        };
                    },
                    // transformer,
                }),
            ],
        });

        return createTRPCOptionsProxy<AppRouter>({
            client,
            queryClient,
        });
    } catch (error) {
        console.error('Error creating TRPC client', error);
        throw error;
    }
};
